export default {
    // Header Section
    "discover_your": "Discover Your",
    "nakshatra": "Nakshatra",
    "birth_star_analysis": "Birth Star Analysis",
    "nakshatra_description": `Nakshatra is one of 27 lunar mansions along the ecliptic, each divided into four padas (quarters). Each pada is linked to specific syllables, often used to choose a newborn’s name based on the Moon’s position.`,

    // Service Information
    "enter_birth_details": "Enter Your Birth Details",
    "complete_nakshatra_analysis": "Complete Nakshatra Analysis",
    "service_price": "Service Price",
    "comprehensive_nakshatra_analysis_note": "Deep dive into your birth star's influence on personality, relationships, and life path",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_nakshatra": "Exact birth time is essential for precise nakshatra identification",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your nakshatra analysis will be delivered in the selected language",

    // Core Nakshatra Features
    "birth_star_identification": "Birth Star (Nakshatra) Identification",
    "personality_traits_detailed": "Detailed Personality & Character Analysis",
    "compatibility_analysis": "Marriage & Relationship Compatibility",
    "career_guidance_nakshatra": "Career Path Based on Birth Star",
    "lucky_elements": "Lucky Colors, Numbers & Gemstones",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Nakshatra Analysis Includes",
    "your_birth_star_detailed": "Your Birth Star (Nakshatra) in Detail",
    "nakshatra_characteristics": "Core Nakshatra Characteristics",
    "pada_analysis": "Pada (Quarter) Analysis",
    "ruling_deity_insights": "Ruling Deity & Spiritual Insights",

    // Actions & Buttons
    "pay_and_generate_analysis": "Get My Nakshatra Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "nakshatra_analysis_processing": "Your Nakshatra analysis is being prepared by our expert Vedic astrologers. You'll receive deep insights into your birth star's influence.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note": "Your detailed nakshatra report will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Nakshatra Analysis Package",
    "detailed_nakshatra_report": "Comprehensive Nakshatra Report (PDF)",
    "birth_star_characteristics": "Birth Star Personality Profile",
    "pada_and_symbol_analysis": "Pada Analysis & Sacred Symbols",
    "compatibility_insights": "Marriage & Partnership Compatibility",
    "lucky_colors_numbers": "Lucky Elements & Remedial Gemstones",

    // Visual Content
    "sample_nakshatra_analysis": "Sample Nakshatra Analysis",
    "sample_nakshatra_description": "Preview of your personalized birth star analysis with detailed insights",
    "popular_nakshatras": "The 27 Nakshatras",

    // Major Nakshatra Names
    "ashwini": "Ashwini - The Horsemen",
    "bharani": "Bharani - The Bearer",
    "kritika": "Kritika - The Cutter",
    "rohini": "Rohini - The Red One",
    "mrigashira": "Mrigashira - The Deer Head",
    "ardra": "Ardra - The Moist One",
    "punarvasu": "Punarvasu - The Restorer",
    "pushya": "Pushya - The Nourisher",
    "ashlesha": "Ashlesha - The Embracer",
    "magha": "Magha - The Mighty",
    "purva_phalguni": "Purva Phalguni",
    "uttara_phalguni": "Uttara Phalguni",

    // Status & Processing
    "your_nakshatra_analysis_status": "Your Nakshatra Analysis Status",
    "processing_your_analysis": "Analyzing Your Birth Star",
    "analysis_processing_message": "Our Vedic astrology experts are studying your nakshatra's cosmic influences and preparing your personalized insights.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Astrology Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Nakshatra-Specific Elements
    "birth_star": "Birth Star (Nakshatra)",
    "nakshatra_lord": "Nakshatra Ruler",
    "ruling_planet": "Governing Planet",
    "nakshatra_symbol": "Sacred Symbol",
    "presiding_deity": "Presiding Deity",
    "gana_type": "Gana Classification",
    "nakshatra_nature": "Inherent Nature",
    "power_animal": "Power Animal",

    // Pada (Quarters) Analysis
    "pada_1": "First Pada (0°-3°20')",
    "pada_2": "Second Pada (3°20'-6°40')",
    "pada_3": "Third Pada (6°40'-10°)",
    "pada_4": "Fourth Pada (10°-13°20')",
    "your_pada": "Your Nakshatra Pada",
    "pada_characteristics": "Pada-Specific Traits",
    "pada_influence": "How Your Pada Shapes You",

    // Personality & Character
    "core_personality": "Core Personality Traits",
    "strengths_weaknesses": "Strengths & Growth Areas",
    "mental_nature": "Mental Disposition",
    "emotional_patterns": "Emotional Patterns",
    "behavioral_tendencies": "Behavioral Tendencies",
    "life_approach": "Approach to Life",

    // Compatibility & Relationships
    "compatible_nakshatras": "Most Compatible Birth Stars",
    "challenging_nakshatras": "Potentially Challenging Matches",
    "marriage_compatibility": "Marriage & Partnership Analysis",
    "friendship_compatibility": "Friendship Dynamics",
    "business_partnership": "Business Collaboration Potential",
    "relationship_advice": "Relationship Guidance",

    // Career & Profession
    "suitable_careers": "Ideal Career Paths",
    "professional_strengths": "Professional Strengths",
    "work_environment": "Optimal Work Environment",
    "leadership_style": "Leadership Approach",
    "business_prospects": "Entrepreneurial Potential",
    "financial_tendencies": "Money Management Style",

    // Health & Wellness
    "health_tendencies": "Health Predispositions",
    "vulnerable_areas": "Areas Requiring Attention",
    "wellness_recommendations": "Health & Wellness Tips",
    "dietary_guidance": "Dietary Recommendations",

    // Spiritual & Remedial
    "spiritual_path": "Spiritual Journey",
    "life_purpose": "Soul's Purpose",
    "karmic_lessons": "Life Lessons",
    "recommended_remedies": "Vedic Remedies",
    "mantras_to_chant": "Beneficial Mantras",
    "meditation_practices": "Meditation Techniques",
    "worship_recommendations": "Deity Worship Guidance",
    "fasting_days": "Auspicious Fasting Days",
    "donation_suggestions": "Charitable Activities",

    // Lucky Elements
    "lucky_colors": "Auspicious Colors",
    "lucky_numbers": "Favorable Numbers",
    "lucky_days": "Best Days of Week",
    "lucky_directions": "Favorable Directions",
    "lucky_gemstones": "Beneficial Gemstones",
    "lucky_metals": "Auspicious Metals",
    "favorable_timing": "Optimal Timing for Important Activities",

    // Detailed Analysis Sections
    "nakshatra_mythology": "Mythological Background",
    "cosmic_connection": "Cosmic Significance",
    "elemental_influence": "Elemental Associations",
    "seasonal_connection": "Seasonal Influence",
    "lunar_mansion": "Lunar Mansion Significance",
    "vedic_wisdom": "Ancient Vedic Insights"
};
